import { sanitizeGameUrl } from '@/utils/sanitize-game-url';

type GameFrameProps = {
  url?: string;
  title?: string;
  allowFullscreen?: boolean;
};

export const GameFrame: React.FC<GameFrameProps> = ({
  title,
  url,
  allowFullscreen,
}: GameFrameProps) => {
  const safeUrl = sanitizeGameUrl(url);

  if (!safeUrl) {
    return <p>Invalid game url</p>;
  }

  return (
    <iframe
      src={safeUrl}
      title={title}
      id="game-client"
      allowFullScreen={allowFullscreen}
    />
  );
};
